import styled from 'styled-components';
import { spacings, font } from 'styles';

export const RequestLocationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 360px;
  padding-top: 50px;
  span {
    margin: ${spacings.space07} 0 ${spacings.space06} 0;
    font-size: ${font.sizes.textSmall};
  }
`;
